<template>
  <div ref="searchField" class="header-category__search" v-clickoutside="hideSearchField" :class="{editor: isEditor, open: true, focused: focus, filled: filled}">
    <div class="field-wrap">
      <input v-on:keyup.enter="fetchData" type="text" ref="searchFieldInput" id="searchFieldInput" @focus="focus = true" @blur="focus = false" class="field" placeholder="Поиск правил"
             v-model="search" autocomplete="off">
      <span @click="resetSearch()" class="field-clear i i-close2"></span>
      <div class="b-wrapper">
          <button class="b" @click="fetchData"></button>
      </div>
    </div>

    <div ref="searchFieldBtn" @click="openSearchField" class="btn-search" :class="{'active': isSearch}">
        <span class="i i-search"></span>
    </div>
  </div>
</template>


<script>

import {mapState} from 'vuex';

export default {
  name: "RulesSearch",
  components: {},
  props: {
    isEditor:
        {
          default: function () {
            return false
          }
        }
  },
  data: function () {
    return {
      unsubscribe: '',
	    focus: false,
    }
  },
  mounted: function () {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type == 'setSearchFocus') {
        this.search = '';
        this.openSearchField();
      }
    });
  },
  beforeDestroy: function () {
    this.unsubscribe();
  },
  computed: {
    filled(){
     return (this.search || '').length > 0;
    },
    search: {
      get() {
        return this.$store.state.rules.searchInputValue;
      },
      set(val) {
        this.$store.commit('rules/setSearchInputValue', val);
      }
    },
    ...mapState({
      isSearch: state => state.rules.isSearch,
      popups: state => state.popups.items,
      item: state => state.rules.editItem,
      openSearch: state => state.rules.openSearchField,
      sections: state => state.rules.sections,
      topSections: state => state.rules.topSections,
      ruleTypesToSearch: state => state.rules.ruleTypesToSearch,
      sectionToSearch: state => state.rules.sectionToSearch,
    }),
    activeTopSection() {
      return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
    },
    activeSection() {
      if (this.sections.length) {
        return this.$route.params.subid ? this.$route.params.subid : this.sections[0].id;
      } else {
        return false;
      }
    },
  },
  watch: {
    ruleTypesToSearch(val) {
      if (val.length > 0) {
        this.fetchData();
      } else {
        this.$store.dispatch('rules/triggerRuleTypeError', true);
      }
    },
    sectionToSearch(val) {
      this.fetchData();
    },
  },
  methods: {
    resetSearch() {
      this.search = '';
      this.$refs.searchFieldInput.focus();

    },
    async fetchData(event, isReset) {
      if(this.$route.name == 'moderator-staff' && (this.search || isReset)){
          this.$router.push({path: '/'});
      }
      if (this.search || isReset) {
          if(document.querySelector('.rules')){
              document.querySelector('.rules').style.opacity = '1';
          }
          this.$store.commit('popups/close', {name: this.popups.addRule.name});
          this.$store.commit('popups/close', {name: this.popups.ruleDetail.name});
          
          if (this.sectionToSearch != undefined) {
            this.$store.commit('rules/SET_SECTION_TO_SEARCH', this.activeTopSection);
          }
          this.$store.dispatch('rules/getItems', {id: this.activeSection, search: this.search, reload: true});

          this.hideSearchField();
      } else {
        this.$refs.searchFieldInput.focus();
      }
    },
    openSearchField: function () {
      this.$store.commit('rules/openSearchField', true);
      this.$refs.searchFieldInput.focus();
      this.$refs.searchFieldInput.select();
    },
    hideSearchField: function () {
      this.$store.commit('rules/openSearchField', false);
    }

  },
  directives: {
    'clickoutside': {
      bind: function (el, binding, vNode) {
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) {
            warn += `Found in component '${compName}'`
          }
          console.warn(warn);
        }
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target) && (!e.target.classList.contains('click-outside-search'))) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler;
        document.addEventListener('mousedown', handler);
      },

      unbind: function (el, binding) {
        document.removeEventListener('mousedown', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
}
</script>
